import { FormikInput } from '../../../cdl/Input/FormikInput';
import { FormikTextArea } from '../../../cdl/TextArea/FormikTextArea';
import { translate } from '../../../common/helpers/translate.helper';
import { Box } from '../../../common/ui/Box';

export const DemandDefinitionDetailsFields = () => (
    <Box display="flex" flexDirection="column" gap={24}>
        <FormikInput
            name="name"
            label={translate('demandDefinition.name')}
            description={translate('demandDefinition.nameDescription')}
            placeholder={translate('demandDefinition.annualLubricantDemand2026Placeholder')}
        />
        <FormikInput
            name="reference"
            label={translate('demandDefinition.reference')}
            markAsOptional
            placeholder={translate('demandDefinition.referencePlaceholder')}
        />
        <FormikTextArea
            name="internalNotes"
            label={translate('demandDefinition.internalNotes')}
            markAsOptional
            description={translate('demandDefinition.notSharedWithSuppliersDescription')}
            placeholder={translate('demandDefinition.addNotesPlaceholder')}
            rows={3}
        />
    </Box>
);
